import axios from '../utils/axios';

export default function fetchAllJobs(adminId,params) {
    return (
        axios.get('/admin/' + adminId + '/published-jobs',{
            params: params
        })
    )
}
